import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["ui-switch", { checked: $setup.value }])
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      class: "ui-switch-input",
      disabled: $props.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.value) = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:checked', ($event.target as HTMLInputElement).checked)))
    }, null, 40, _hoisted_1), [
      [_vModelCheckbox, $setup.value]
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "ui-switch-track" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "ui-switch-thumb" }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "ui-switch-focus-ring" }, null, -1))
  ], 2))
}